import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { HeaderServiceProxy } from '@telecom/shared/services/header-service/header-service-proxy';
import { isUserLogin } from '@telecom/shared/startup/user-auth';
import { OnboardingBrowserRuntimeImpl } from '../../common/services/impls/onboarding-browser-runtime';
import type { DesignFtoOnboardingRuntime } from '../design-fto-onboarding-runtime';

/** Design FTO 首页首次引导 runtime。 */
@injectable()
export class DesignFtoOnboardingRuntimeImpl
    extends OnboardingBrowserRuntimeImpl
    implements DesignFtoOnboardingRuntime {
    constructor(
        /** 提供当前登录账号信息。 */
        @inject(HeaderServiceProxy)
        private readonly _headerServiceProxy: HeaderServiceProxy,
    ) {
        super();
    }

    /** 获取用于隔离首次展示状态的登录账号 ID。 */
    getIdentityId(): Promise<string> {
        return Promise.resolve(
            this._headerServiceProxy.headerService.account?._info.account_id ?? '',
        );
    }

    /** 查询当前浏览器用户是否已经登录。 */
    isUserLogin(): Promise<boolean> {
        return isUserLogin();
    }
}
